export const Z_INDEX_NAVIGATION = 100;
export const Z_INDEX_DROPDOWN = 200;
export const Z_INDEX_NOTIFICATIONS = 300;
export const Z_INDEX_OVERLAY = 400;
export const Z_INDEX_MODAL = 500;
